import * as actionTypes from 'constants/ActionTypes';

const ldRates = (state = {
    items: [],
    isLoaded: false,
    searchText: '',
}, action) => {
    switch (action.type) {
        case actionTypes.GET_LOADING_AND_DISCHARGING.REQUEST:
            return {
                ...state,
                items: [],
                isLoaded: false,
            };
        case actionTypes.GET_LOADING_AND_DISCHARGING.SUCCESS: {
            const items = action.data.map((item) => {
                return {
                    ...item,
                    isUpdate: false,
                    prevState: item,
                };
            });

            return {
                ...state,
                items,
                isLoaded: true,
            };
        }
        case actionTypes.GET_LOADING_AND_DISCHARGING.FAILURE:
            return {
                ...state,
                isLoaded: true,
            };
        case actionTypes.UPDATE_LOADING_AND_DISCHARGING.REQUEST: {
            return {
                ...state,
            };
        }
        case actionTypes.UPDATE_LOADING_AND_DISCHARGING.SUCCESS: {
            const items = state.items.map((item) => {
                if (action.item._id === item._id) {
                    return {
                        ...action.item,
                        prevState: action.item,
                        isUpdate: false,
                    };
                }

                return item;
            });

            return {
                ...state,
                items,
            };
        }
        case actionTypes.UPDATE_LOADING_AND_DISCHARGING.FAILURE: {
            const items = state.items.map((item) => {
                if (action.item._id === item._id) {
                    return {
                        ...item,
                        isUpdate: true,
                    };
                }
                return item;
            });

            return { ...state, items };
        }
        case actionTypes.DELETE_LOADING_AND_DISCHARGING.REQUEST:
            return {
                ...state,
            };
        case actionTypes.DELETE_LOADING_AND_DISCHARGING.SUCCESS: {
            const items = state.items.filter((item) => {
                return !(action.item._id === item._id);
            });

            return {
                ...state,
                items,
            };
        }
        case actionTypes.DELETE_LOADING_AND_DISCHARGING.FAILURE: {
            const items = state.items.map((item) => {
                if (action.item._id === item._id) {
                    return {
                        ...item,
                    };
                }

                return item;
            });

            return {
                ...state,
                items,
            }
        }

        case actionTypes.SAVE_STATUS_LOADING_AND_DISCHARGING: {
            const items = state.items.map((item) => {
                if (action.item._id === item._id) {
                    return {
                        ...action.item,
                        prevState: item.prevState,
                        isUpdate: true,
                    };
                }

                return item;
            });

            return {
                ...state,
                items,
            };
        }

        case actionTypes.SEARCH_LOADING_AND_DISCHARGING:
            return {
                ...state,
                searchText: action.search,
            };

        default:
            return state;
    }
};

export default ldRates;



// WEBPACK FOOTER //
// ./app/reducers/cargoes/ldRates.js